var map = {
	"./armor_icon.png": 19374,
	"./belt_icon.png": 71184,
	"./boots_icon.png": 81936,
	"./cancel_icon.png": 24563,
	"./cd_icon.png": 79994,
	"./confirm_icon.png": 32817,
	"./gloves_icon.png": 51947,
	"./helmet_icon.png": 24792,
	"./left_ring_icon.png": 18585,
	"./necklace_icon.png": 92817,
	"./right_ring_icon.png": 66044,
	"./ring_icon.png": 91475,
	"./target_icon.png": 18196,
	"./weapon_icon.png": 69409
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75885;